/**
 * NotFound — 404-Seite für unbekannte Routen.
 *
 * Wird als notFoundComponent im __root.tsx eingebunden und läuft
 * damit innerhalb des AppShell-Layouts (sofern ein Auth-Layout aktiv ist)
 * oder als standalone bei komplett unbekannten Pfaden.
 */
import { useEffect } from 'react'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { setDynamicMeta, setNoIndex } from '../lib/seo'
import { useAuthStore } from '../stores/authStore'

export function NotFound() {
  const { t } = useTranslation('components')
  // F-SW7-5: Ausgeloggte Besucher sollen zur Startseite ("/"), nicht in den
  // Login-Redirect von /dashboard laufen. Eingeloggte User bleiben beim Dashboard.
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const backTarget = isAuthenticated ? '/dashboard' : '/'
  const backLabel = isAuthenticated ? t('notFound.backToDashboard') : t('notFound.backToHome')

  useEffect(() => {
    setDynamicMeta(
      t('notFound.metaTitle'),
      t('notFound.metaDescription'),
    )
    // nginx antwortet auf unbekannte Pfade mit 200 und der SPA-Hülle; ohne
    // dieses noindex sammelt Google beliebig viele Dubletten ein.
    return setNoIndex()
  }, [t])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        gap: 16,
        padding: '48px 24px',
      }}
      data-testid="not-found-page"
    >
      <div
        style={{
          fontSize: 72,
          fontWeight: 700,
          color: 'var(--text-subtle)',
          lineHeight: 1,
          letterSpacing: '-0.04em',
        }}
      >
        404
      </div>
      <h1
        style={{
          fontSize: 22,
          fontWeight: 600,
          margin: 0,
        }}
      >
        {t('notFound.title')}
      </h1>
      <p
        style={{
          color: 'var(--text-subtle)',
          maxWidth: 420,
          margin: 0,
          fontSize: 15,
          lineHeight: 1.5,
        }}
      >
        {t('notFound.description')}
      </p>
      <Link
        to={backTarget}
        className="btn btn-primary"
        style={{ marginTop: 8 }}
      >
        {backLabel}
      </Link>
    </div>
  )
}
